import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Environment {
    constructor({ model, texture }) {
        this.experience = new Experience()
        this.worldGroup = this.experience.worldGroup
        this.resources = this.experience.resources
        this.renderer = this.experience.renderer

        this.isBackground = model === 'backgroundModel'

        // Setup
        this.modResource = this.resources.items[model]
        this.texResource = this.resources.items[texture]

        this.setTextures()
        this.setMaterial()
        this.setModel()
    }

    setTextures() {
        this.textures = {}

        this.textures.color = this.texResource
        this.textures.color.colorSpace = THREE.SRGBColorSpace
    }

    setMaterial() {
        // Check if texture is transparent
        // const src = this.textures.color.source?.data?.src || ''
        // const isTransparent = src.toLowerCase().endsWith('.png')

        this.material = new THREE.MeshBasicMaterial({ // MeshBasicMaterial = no shader & shadows
            color: "#ffffff",
            map: this.textures.color,
            alphaTest: 0.5,
            precision: 'lowp',
        })
    }

    setModel() {
        this.model = this.modResource.scene
        this.model.scale.set(0.33, 0.33, 0.33)

        // this.baseScale = 0.33

        // this.defaultPosition = new THREE.Vector3(0, 0, 0)
        // this.model.position.copy(this.defaultPosition)

        if (this.isBackground) {
            this.worldGroup.add(this.model)
        } else {
            this.experience.xrRig.add(this.model)
        }

        this.model.traverse(child => {
            if (child instanceof THREE.Mesh) {
                child.material = this.material
                child.receiveShadow = true
            }
        })
    }

    update() {
        // Hide background in XR mode
        if (this.isBackground) {
            this.model.visible = !this.renderer.instance.xr.isPresenting
        }

        // const xr = this.renderer.instance.xr.isPresenting
        // if (xr) {
        //     this.model.position.copy(this.defaultPosition)
        //     this.model.quaternion.identity()
        //     const anchored =
        //         this.handTracking.isAnyHandTracked() || this.hitTesting.hasHit()
        //     if (anchored) {
        //         this.model.scale.set(1, 1, 1)
        //     } else {
        //         this.model.scale.set(this.baseScale, this.baseScale, this.baseScale)
        //     }
        //     return
        // }
        //
        // this.model.position.copy(this.defaultPosition)
        // this.model.quaternion.identity()
        // this.model.scale.set(this.baseScale, this.baseScale, this.baseScale)
    }

}